import * as Yup from "yup";
import {FIELD_REQUIRED, FIELD_STRING,} from "../../../../common/constants/validationErrors";

import * as paiementSouscriptionFormNames from "./paiementSouscriptionFormNames";

export const paiementSouscriptionValidationSchema = Yup.object().shape({
  [paiementSouscriptionFormNames.PAIEMENT_SOUSCRIPTION_PLATEFORME_PAIEMENT_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING).required(FIELD_REQUIRED),
  [paiementSouscriptionFormNames.PAIEMENT_SOUSCRIPTION_MODE_PAIEMENT_FORM_NAME]:
    Yup.string()
      .typeError(FIELD_STRING)
      .when(
        paiementSouscriptionFormNames.PAIEMENT_SOUSCRIPTION_PLATEFORME_PAIEMENT_FORM_NAME,
        {
          is: (value) => {
            return value === "cmi";
          },
          then: Yup.string().typeError(FIELD_STRING).required(FIELD_REQUIRED),
        }
      ),
});
